import { format } from 'date-fns';
import Controller from './controller';
import { PrimaryTextXs, NoteText, SecondaryTextXs300 } from 'atoms';
import internalState from './internalState';
import { DateText } from './atoms';
import { ContainerComponent, wrap } from 'AppReact';
import { NoteMessageWrapper, Mt1, Mx3, FlexCenterBetweenWrapper, CustomHeight } from 'wrappers';
import { TextButton } from 'molecules';
import { getNoteText } from 'utils';
import NoteMediaFiles from '../noteMediaFiles';
import { ActionsDropdown } from './containers';
import NoteInput from '../noteInput';

export const definition = {
  name: 'Note',
  controller: Controller,
  initialProps: ({ event, currentUser, acceptDocuments, personsToMention, displayBottom }) => ({
    event,
    acceptDocuments,
    currentUser,
    isEditable: currentUser === event?.created_by || event?.description_history?.length > 0,
    personsToMention,
    displayBottom
  }),
  props: internalState,
  elements: [
    {
      wrapper: CustomHeight,
      name: '__transparent__',
      displayState: ({ }) => ({ width: '300px' }),
      elements: [
        {
          component: wrap(NoteInput, CustomHeight),
          renderIf: ({ isEditing }) => isEditing,
          name: 'NoteInput',
          bindings: ({ event, acceptDocuments, personsToMention, displayBottom }) => ({
            isEditing: true,
            acceptDocuments,
            displayBottom,
            personsToMention: personsToMention ?? [],
            localUrls: event?.attachments?.map(a => a.url) ?? [],
            placeholder: 'Use @ to mention someone',
            content_types: event?.attachments?.map(e => e.content_type), uuids: event?.attachments?.map(a => a.uuid) ?? [], inputVal: event?.description ?? ''
          })
        }
      ]
    },
    {
      wrapper: NoteMessageWrapper,
      name: 'NoteBody',
      renderIf: ({ isEditing }) => !isEditing,
      displayState: ({ event, currentUser }) => ({ hasImage: !!event?.src && event?.file_type?.includes("image"), hasVideo: !!event?.src && event?.file_type?.includes("image"), right: currentUser === event?.created_by }),
      elements: [
        {
          wrapper: FlexCenterBetweenWrapper,
          name: 'TopWrapper',
          elements: [
            {
              component: PrimaryTextXs,
              name: 'SenderName',
              displayValue: ({ event }) => `${event?.created_by} ${event?.created_by_type === 'resident' ? '(Resident)' : ''}`,
            },
            {
              component: ActionsDropdown,
              renderIf: ({ isEditable }) => isEditable,
              name: 'ActionsDropdown',
              bindings: ({ event, currentUser }) => ({ event, isEditable: currentUser === event?.created_by }),
            }
          ]
        },
        {
          component: wrap(NoteMediaFiles, Mt1),
          name: 'Image',
          renderIf: ({ event }) => !!event.attachments,
          bindings: ({ event }) => ({
            files: event.attachments,
            popup: { text: 'Click to see full screen', position: 'top' }
          })
        },
        {
          component: wrap(NoteText, Mt1),
          name: 'NoteText',
          displayValue: ({ event, translated, translation }) => {
            if (translated) {
              return getNoteText(translation)
            } else {
              return getNoteText(event?.description)
            }
          }
        },
        {
          wrapper: wrap(FlexCenterBetweenWrapper, Mt1),
          name: 'BottomWrapper',
          elements: [
            {
              component: DateText,
              name: 'NoteDate',
              displayValue: ({ event }) => event.datetime ? format(event.datetime, 'MM/dd/yy hh:mm a') : '',
              displayState: ({ event, currentUser }) => ({ right: currentUser === event?.created_by })
            },
            {
              component: SecondaryTextXs300,
              renderIf: ({ event }) => event?.description_history?.length > 0,
              name: 'EditedText',
              displayValue: ({ }) => 'Edited'
            }

          ]
        }
      ]
    },
    {
      component: wrap(TextButton, Mt1),
      name: 'TranslateButton',
      renderIf: ({ event, isEditing }) => event?.description && !isEditing,
      bindings: ({ translated, event, translation, translatedMessage }) => ({ translatedMessage, mobileSmall: true, title: translated ? 'Translate' : 'Traducir', translated, event, translation })
    },
    {
      component: wrap(TextButton, Mt1),
      name: 'CancelEdit',
      renderIf: ({ isEditing }) => isEditing,
      bindings: ({ }) => ({ mobileSmall: true, title: 'Cancel Edit' })
    }
  ]
};

export default wrap(ContainerComponent(definition), Mx3);